import {
  GERMANY_NAME_ALLOWED_CHARACTERS,
  GERMANY_NAME_VALID_CHARACTERS,
  mustNotContainNumber,
  noConsecutiveSpaces,
  noWhiteStartOrEnd,
  required,
  validateAllowedCharacters
} from '@ps/web-shared-validators';
import React from 'react';
import { useField } from 'react-final-form';

import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTWCL_Birth_name,
  TXTWCL_Please_enter_a_nameX,
  TXTWCL_The_name_you_have_entered_is_i_ELL
} from './BirthName.messages.json';

const MAX_LENGTH = 85;

const BirthName: React.FC = () => {
  const {
    input: { value }
  } = useField('birthName');

  return (
    <TextInput
      id="birthName"
      label={TXTWCL_Birth_name}
      value={value}
      maxLength={MAX_LENGTH}
      checkDisabled
      validators={[
        required(TXTWCL_Please_enter_a_nameX),
        noWhiteStartOrEnd,
        noConsecutiveSpaces,
        mustNotContainNumber(TXTWCL_The_name_you_have_entered_is_i_ELL, true),
        validateAllowedCharacters(GERMANY_NAME_ALLOWED_CHARACTERS, GERMANY_NAME_VALID_CHARACTERS)
      ]}
    />
  );
};

export default BirthName;
